import React from 'react';
import { Box, Stack, Typography } from '@mui/material';

import { ReturnPageButton } from './button';

const PageHeader = ({ title, showBack = false, onBack, titleAdornment, actions, sx }) => {
    return (
        <Stack
            direction="row"
            justifyContent="space-between"
            alignItems="center"
            flexWrap="wrap"
            spacing={ 2 }
            sx={ { mb: 1, ...sx } }
        >
            <Stack direction="row" alignItems="center" flexWrap="wrap" spacing={ 2 }>
                { showBack && onBack && (
                    <ReturnPageButton onClick={ onBack }/>
                ) }
                <Typography variant="h4" component="h1" sx={ { fontWeight: 600, color: 'text.primary', m: 0 } }>
                    { title }
                </Typography>

                { titleAdornment && (
                    <Box sx={ { display: 'flex', gap: 1, alignItems: 'center', flexWrap: 'wrap' } }>
                        { titleAdornment }
                    </Box>
                ) }
            </Stack>

            { actions && (
                <Box sx={ { display: 'flex', gap: 1, alignItems: 'center' } }>
                    { actions }
                </Box>
            ) }
        </Stack>
    );
};

export default PageHeader;